<template>
	<component :is="Is" :value="value" :config="config" :title="title" :options="options" :icon="icon" @change="handleChange" @click="handleClick">
		<slot></slot>
		<slot slot="button" name="button"></slot>
	</component>
</template>
<script>
import Dialog from './Dialog.vue'
import Pop from './Pop.vue'

export default {
	props: {
		value: Number,
		config: Object,
		title: String,
		icon: String,
		theme: { type: String, default: '' },
		options: Array
	},
	components: { Dialog, Pop },
	computed: {
		Is () {
			switch (this.theme.toLowerCase()) {
				case 'pop':
					return 'Pop'
				default:
					return 'Dialog'
			}
		}
	},
	methods: {
		handleChange (val) {
			this.$emit('change', val)
		},
		handleClick (val) {
			this.$emit('click', val)
		}
	}
}
</script>
